// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VehicleProperties_wrapper__1sSXU","label":"VehicleProperties_label__3IgO5","value":"VehicleProperties_value__3ILWD","information":"VehicleProperties_information__2X_8O"};